import * as React from "react"
import { useComputed } from "@preact/signals-react"
import { Grid } from "@mui/material"

import AdminSkuModalSkuSelector from "./Sku"
import AdminSkuModalSkuInfo from "./SkuInfo"
import { adminSkuModalData } from "../../@signals"


export default function AdminSkuModalContent() {
    const selectedSku = useComputed(() => adminSkuModalData.value.sku)

    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <AdminSkuModalSkuSelector />
        </Grid>

        {selectedSku.value && <Grid item xs={12}>
            <AdminSkuModalSkuInfo/>
        </Grid>}
    </Grid>
}